import { Avatar, Box, Typography } from '@mui/material';
import React from 'react';
import NavBar from '../../components/navbar/navbar';
import { emergencies } from '../../utils/data';
import ComunicacionRH from '../../assets/comunicacionRH.jpg';
import { useNavigate } from 'react-router-dom';

const Emergencies: React.FC = () => {
    const navigate = useNavigate();

    const handleCardClick = (id: number) => {
        navigate("/article", {
            state: { id: id },
        });
    };

    const renderEmergencies = () => {
        return emergencies.map((item) => (
            <Box onClick={() => handleCardClick(item.id)} display="flex" flexDirection={item.id%2 === 1 ? 'row-reverse' : 'row' }>
                <Box margin={"auto"}>
                    <Typography variant="subtitle1" color="textDisabled">
                        {item.subtitle}
                    </Typography>
                    <Typography variant="h6" margin={"16px 0"} >
                        {item.title}
                    </Typography>
                    <Box display="flex" alignItems="center" gap={"16px"} >
                        <Avatar alt="Remy Sharp" src={ComunicacionRH} />
                        <Typography variant='body1'>Comunicación RH</Typography>
                    </Box>
                </Box>
                <Box maxWidth="600px">
                    <img src={item.image} width="100%" alt={item.title} />
                </Box>
            </Box>
        ));
    };

    return(
        <Box>
            <NavBar active="emergencias"/>
            <Box m={5}>
                {renderEmergencies()}
            </Box>
        </Box>
    )
}

export default Emergencies;